FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */
    var ELEM = '[data-fd="excel-navigation"]';

    $.widget("custom.excelNavigation", {
        options: {
            arrowNav: true,
            enterNav: true,
            tabNav: true,
            ctrlNav: true,
            pageNav: true,
            homeEndNav: true,
            selectedRowClass: "selected-row highlight-child-withborder",
            selectedColumnClass: "selected-column",
            selectedCellClass: "selected-cell",
            selectOnFocus: true,
            setOnBlur: false,
            rowSelector: "tr:not(.footer)",
            columnSelector: "td",
            inputSelectors: "input:not(:hidden),select,span[data-fd=checkbox]",
            pageSize: 0
        },
        _handleKeyDown: function (event) {
            var self = event.data;
            self._setTarget(event.target);

            // Suppress navigation when an auto-complete is open.
            if ($(event.target).is('[data-fd=autocomplete]') && $(event.target).autocomplete('widget').is(':visible') && (event.keyCode == keyCode.UPARROW || event.keyCode == keyCode.DOWNARROW)) {
                return;
            }

            switch (event.keyCode) {
                case keyCode.HOME:
                    if (self.options.homeEndNav && !event.ctrlKey)
                        self.setIndex(self.getRowIndex(), 0, seek.NONE, seek.RIGHT);
                    if (self.options.homeEndNav && event.ctrlKey) {
                        self.setIndex(0, self.getColumnIndex(), seek.DOWN, seek.NONE);
                        self.setIndex(self.getRowIndex(), 0, seek.NONE, seek.RIGHT);
                    }
                    break;
                case keyCode.END:
                    if (self.options.homeEndNav && !event.ctrlKey)
                        self.setIndex(self.getRowIndex(), self.getColumnCount() - 1, seek.NONE, seek.LEFT);
                    if (self.options.homeEndNav && event.ctrlKey) {
                        self.setIndex(self.getRowCount() - 1, self.getColumnIndex(), seek.UP, seek.NONE);
                        self.setIndex(self.getRowIndex(), self.getColumnCount() - 1, seek.NONE, seek.LEFT);
                    }
                    break;
                case keyCode.UPARROW:
                    if (self.options.arrowNav && !event.ctrlKey)
                        self.setIndex(self.getRowIndex() - 1, self.getColumnIndex(), seek.UP, seek.NONE);
                    if (self.options.ctrlNav && event.ctrlKey)
                        self.setIndex(0, self.getColumnIndex(), seek.DOWN, seek.NONE);
                    break;
                case keyCode.DOWNARROW:
                    if (self.options.arrowNav && !event.ctrlKey)
                        self.setIndex(self.getRowIndex() + 1, self.getColumnIndex(), seek.DOWN, seek.NONE);
                    if (self.options.ctrlNav && event.ctrlKey)
                        self.setIndex(self.getRowCount() - 1, self.getColumnIndex(), seek.UP, seek.NONE);
                    break;
                case keyCode.LEFTARROW:
                    if (self.options.arrowNav && !event.ctrlKey)
                        self.setIndex(self.getRowIndex(), self.getColumnIndex() - 1, seek.NONE, seek.LEFT);
                    if (self.options.ctrlNav && event.ctrlKey)
                        self.setIndex(self.getRowIndex(), 0, seek.NONE, seek.RIGHT);
                    break;
                case keyCode.RIGHTARROW:
                    if (self.options.arrowNav && !event.ctrlKey)
                        self.setIndex(self.getRowIndex(), self.getColumnIndex() + 1, seek.NONE, seek.RIGHT);
                    if (self.options.ctrlNav && event.ctrlKey)
                        self.setIndex(self.getRowIndex(), self.getColumnCount() - 1, seek.NONE, seek.LEFT);
                    break;
                case keyCode.TAB:
                    if (self.options.tabNav && !event.shiftKey)
                        self.setIndex(self.getRowIndex(), self.getColumnIndex()); // +1 Default browser code already moved focuse.
                    if (self.options.tabNav && event.shiftKey)
                        self.setIndex(self.getRowIndex(), self.getColumnIndex()); // -1 Default browser code already moved focuse.
                    break;
                case keyCode.ENTER:
                    if (self.options.enterNav && !event.shiftKey)
                        self.setIndex(self.getRowIndex() + 1, self.getColumnIndex(), seek.DOWN, seek.NONE);
                    if (self.options.enterNav && event.shiftKey)
                        self.setIndex(self.getRowIndex() - 1, self.getColumnIndex(), seek.UP, seek.NONE);
                    break;
                case keyCode.PAGEUP:
                    if (self.options.pageNav)
                        self.setIndex(Math.max(self.getRowIndex() - self.options.pageSize, 0), self.getColumnIndex(), seek.DOWN, seek.NONE);
                    break;
                case keyCode.PAGEDOWN:
                    if (self.options.pageNav)
                        self.setIndex(Math.min(self.getRowIndex() + self.options.pageSize, self.getRowCount() - 1), self.getColumnIndex(), seek.UP, seek.NONE);
                    break;
                case keyCode.ESC:
                    if (self.options.setOnBlur) {
                        $(event.target).val($(event.target).data("initial"));
                        if (self.options.selectOnFocus && $(event.target).is('input,textarea'))
                            event.target.setSelectionRange(0, $(event.target).val().length)
                    }
                    break;
            }

            // Suppress arrow key's on dropdown and navigate instead. (User can press space or enter to get the list)
            if ($(event.target).is('select') && (event.keyCode == keyCode.LEFTARROW || event.keyCode == keyCode.RIGHTARROW || event.keyCode == keyCode.UPARROW || event.keyCode == keyCode.DOWNARROW)) {
                event.preventDefault();
            }
        },
        _handleFocus: function (event) {
            var self = event.data;
            self._setTarget(event.currentTarget);
            var row = self.getRowIndex();
            var column = self.getColumnIndex();

            var rowElm = self.getRow(row);
            var colElm = self.getColumn(column, rowElm);
            self._highlightSelected(rowElm, colElm);

            if (self.options.selectOnFocus && $(event.target).is('input,textarea'))
                event.target.setSelectionRange(0, $(event.target).val().length)
        },
        _handleBlur: function () {
            $(this).data("initial", $(this).val());
        },
        _handleResize: function (event) {
            var self = event.data;
            self.options.pageSize = Math.round((window.innerHeight - parseInt($(".site-body-content ").css("margin-top"))) / $("tr:first-child", self.element).height()) - 1;
        },
        _create: function () {
            this.element.addClass("excel-navigation");
            var self = this;

            // Default page size rule.
            if (!self.options.pageSize) {
                self.options.pageSize = Math.round((window.innerHeight - parseInt($(".site-body-content ").css("margin-top"))) / $("tr:first-child", self.element).height()) - 1;
                $(window).on("resize", this, this._handleResize);
            }
            
            var fields = $(self.options.inputSelectors, this.element);
            if (self.options.setOnBlur) {
                fields.each(function (i) {
                    $(this).data("initial", $(this).val());
                });
                this.element.on("blur", self.options.inputSelectors, this, this._handleBlur);
            }
            this.element
                .on("keydown", self.options.inputSelectors, this, this._handleKeyDown)
                .on("focus", self.options.inputSelectors, this, this._handleFocus);
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.refresh();
        },
        refresh: function () {
            
        },
        _destroy: function () {
            this.element.removeClass("excel-navigation");
            this.element
                .off("keydown", this.options.inputSelectors, this._handelKeyDown)
                .off("focus", this.options.inputSelectors, this._handleFocus)
                .off("blur", this.options.inputSelectors, this._handleBlur);
            $(window).off("resize", this, this._handleResize);
        },
        _highlightSelected: function (rowElm, colElm) {
            var self = this;
            if (self.options.selectedRowClass) {
                $(self.options.rowSelector, self.element).removeClass(self.options.selectedRowClass);
                rowElm.addClass(self.options.selectedRowClass);
            }
            if (self.options.selectedColumnClass) {
                $(self.options.columnSelector, self.element).removeClass(self.options.selectedColumnClass);
                $(self.options.rowSelector, self.element).find(self.options.columnSelector + ":eq(" + colElm.index() + ")").addClass(self.options.selectedColumnClass);
            }
            if (self.options.selectedCellClass) {
                $(self.options.columnSelector, self.element).removeClass(self.options.selectedCellClass);
                colElm.addClass(self.options.selectedCellClass)
            }
        },
        _setTarget: function (target) {
            this._targetElm = $(target);
        },
        _target: function () {
            return this._targetElm == undefined ? $(':focus') : this._targetElm;
        },
        getColumnIndex: function () {
            return this._target().closest(this.options.columnSelector).index();
        },
        getRowIndex: function () {
            return this._target().closest(this.options.rowSelector).index();
        },
        getRowCount: function () {
            return this._target().closest(this.options.rowSelector).siblings(this.options.rowSelector).length + 1;
        },
        getColumnCount: function () {
            return this._target().closest(this.options.columnSelector).siblings(this.options.columnSelector).length + 1;
        },
        getRow: function (row) {
            return this.element.find(this.options.rowSelector + ":eq(" + row + ")");
        },
        getColumn: function (column, rowElm) {
            return rowElm.find(this.options.columnSelector + ":eq(" + column + ")");
        },
        setTarget: function (target) {
            this._setTarget(target);
            this.setIndex(this.getRowIndex(), this.getColumnIndex());
        },
        setIndex: function (row, column, seekRow, seekColumn) {
            var self = this;
            row = Math.max(Math.min(row, self.getRowCount() - 1), 0);
            column = Math.max(Math.min(column, self.getColumnCount() - 1), 0);
            seekRow = seekRow || 0;
            seekColumn = seekColumn || 0;

            var rowElm = self.getRow(row);
            var colElm = self.getColumn(column, rowElm);
            if ($(self.options.inputSelectors, colElm).length == 0 && seekRow != 0) {
                var foundRow = false;
                var rowCount = self.getRowCount();
                for (var i = row + seekRow; i < rowCount - 1 && i > 0; i += seekRow) {
                    rowElm = self.getRow(i);
                    colElm = self.getColumn(column, rowElm);
                    if ($(self.options.inputSelectors, colElm).length > 0) {
                        row = i;
                        foundRow = true;
                        break;
                    }
                }
                if (!foundRow) {
                    row = self.getRowIndex();
                    rowElm = self.getRow(row);
                    colElm = self.getColumn(column, rowElm);
                }
            }

            if ($(self.options.inputSelectors, colElm).length == 0 && seekColumn != 0) {
                var foundColumn = false;
                var columnCount = self.getColumnCount();
                for (var i = column + seekColumn; i < columnCount - 1 && i > 0; i += seekColumn) {
                    colElm = self.getColumn(i, rowElm)
                    if ($(self.options.inputSelectors, colElm).length > 0) {
                        column = i;
                        foundColumn = true;
                        break;
                    }
                }
                if (!foundColumn) {
                    column = self.getColumnIndex();
                    colElm = self.getColumn(column, rowElm);
                }
            }

            var inputElm = $(self.options.inputSelectors, colElm);
            if (self._target()[0] == inputElm[0]) {
                inputElm.blur();
            }

            self._highlightSelected(rowElm, colElm);
            inputElm.focus();

            if (self.options.selectOnFocus && inputElm.is('input,textarea'))
                setTimeout(function () { // Workaround for other code causing conflicts.
                    inputElm[0].setSelectionRange(0, inputElm.val().length);
                }, 1);
        }
    });
    
    function setExcelNavigation(container) {
        $(ELEM, container).excelNavigation();
    }

    var seek = {
        NONE: 0,
        LEFT: -1,
        RIGHT: 1,
        UP: -1,
        DOWN: 1
    };

    var keyCode = {
        DOWNARROW: 40,
        UPARROW: 38,
        RIGHTARROW: 39,
        LEFTARROW: 37,
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        PAGEUP: 33,
        PAGEDOWN: 34,
        HOME: 36,
        END: 35
    };
    
    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setExcelNavigation = function (container, defaults) {
        setExcelNavigation(container, defaults);
    };

    return child;
}(jQuery, FD));